import { IFavoritePropertyDetails } from "../interfaces/IFavorite";
import useFavoritePropertiesInsideShape from "./useFavoritePropertiesInsideShape";
import useFocusShape from "./useFocusShape";

export default function (properties: IFavoritePropertyDetails[]): IFavoritePropertyDetails[] {
    return useFavoritePropertiesInsideShape(properties, useFocusShape());
}